module.exports = __webpack_public_path__ + "static/flags/SN-6061c38052e401446c3c845ef863e788.gif";